import { ReactNode } from 'react';
import { useRotatingClip } from '../hooks';
import { VideoAreaClip } from '../types';
import { CrossfadingBackground } from './CrossfadingBackground.tsx';
import { BgOverlay } from '@shared-components';

type VideoAreaProps = {
  children?: ReactNode;
  clips?: VideoAreaClip[];
};

export const VideoArea = (props: VideoAreaProps) => {
  const { clips = [] } = props;
  const { type: clipType, imageUrl, videoUrl } = useRotatingClip(clips);

  return (
    <div className='position-relative overflow-hidden'>
      <div className='ltn__slide-animation-active'>
        <CrossfadingBackground
          imageUrl={
            imageUrl || clips.filter((c) => c.type === 'image')?.[0]?.url
          }
        />

        {videoUrl && (
          <video
            autoPlay
            muted
            loop
            playsInline
            id='headlineVideo'
            poster={imageUrl}
            style={{
              opacity: clipType === 'video' ? 1 : 0,
              transition: 'opacity 1s ease-in-out',
            }}
          >
            <source src={videoUrl} type='video/mp4' />
          </video>
        )}

        <BgOverlay
          className='ltn__slide-item ltn__slide-item-2 ltn__slide-item-7'
          color='theme-black'
          opacity={30}
          style={{ ['--ltn__paragraph-color' as string]: 'silver' }}
        >
          {/* Adjusted paragraph color so that it is visible over images. */}
          {props.children}
        </BgOverlay>
      </div>
    </div>
  );
};
